import React from 'react';
import Navbar from '../Shared/Navbar';

const NotFound = () => {
    return (
        <div>
            <Navbar/>
            <div className='flex justify-center'>
                <img src="https://i.ibb.co/z8rJQdv/not-found-img.jpg" alt="" />
            </div>
        </div>
    );
};

export default NotFound;